const initialState ={
isLoading: true,
subject:"",
message:"",
myfiles:""
}
export default initialState;